<template>
  <!-- 初评页面 -->
  <div class="judgeList">
    <a-row
      :gutter="24"
    >
      <a-col span="18">
        <div class="searchBox">
          <!-- 点击初评进入查看参赛作品，所有作品将展示3-5张图片和最多500字符的作品描述。 -->
          <div style="margin-bottom: 5px;">{{ $t('admin-judge/tip2') }}</div>
          <a-row :gutter="24">
            <!-- 名称和搜索区域 -->
            <a-col
              span="8"
              style="display: flex;"
            >
              <div class="tag">
                {{ $t('admin-judge/name') }}
              </div>
              <a-input
                v-model="form.search"
                :placeholder="$t('admin-judge/codeOrName')"
              />
              <a-button
                type="primary"
                @click="getList"
              >
                {{ $t("user-productInfo-myProduct/search") }}
              </a-button>
            </a-col>
            <!-- 初评状态 -->
            <a-col span="8" style="display: flex;">
              <div class="tag" style="width: 7em;">
                {{ $t('admin-judge/judgeStatus') }}
              </div>
              <a-select v-model="form.status" style="flex: 1;" @change="getList">
                <a-select-option :value="''">{{ $t('admin-judge/total') }}</a-select-option>
                <a-select-option :value="0">{{ $t('admin-judge/noScore') }}</a-select-option>
                <a-select-option :value="1">{{ $t('admin-judge/hasScore') }}</a-select-option>
              </a-select>
            </a-col>
            <!-- 初评 -->
            <a-col v-if="user.role !== 3" span="8" style="display: flex;">
              <div class="tag">
                {{ $t('admin-judge/judge') }}
              </div>
              <a-select v-model="form.user_id" style="flex: 1;" @change="getList">
                <a-select-option
                  v-for="item in users"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </div>
      </a-col>
      <a-col span="6">
        <div class="infoBox">
          <!-- 数据统计显示 -->
          <div style="margin-bottom: 5px;">数据统计</div>
          <!-- 第一行：总数、已筛数量 -->
          <div style="margin-bottom: 3px;">总数：{{ count }}&nbsp;&nbsp;&nbsp;&nbsp;已筛数量：{{ review_num }}</div>
          <!-- 第二行：已推荐、未推荐 -->
          <div>已推荐：{{ recommend_num }}&nbsp;&nbsp;&nbsp;&nbsp;未推荐：{{ not_recommend_num }}</div>
          <!-- 第三行：分类最大推荐数 -->
          <div v-if="max_num !== null && max_num !== undefined">分类最大推荐数：{{ max_num }}</div>
        </div>
      </a-col>
    </a-row>
    <a-table
      :columns="columns"
      :data-source="list"
      class="table"
      :pagination="pagination"
      row-key="id"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="pageChange"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text,row,index">
        <div>
          {{ index + 1 }}
        </div>
      </span>
      <!-- 图片 -->
      <span slot="image" slot-scope="text">
        <div>
          <img :src="text[0] && text[0].thumb_image_url" alt style="cursor: pointer; width: 300px; height: auto; max-height: 200px; object-fit: cover;" @click="preview(text)">
        </div>
      </span>
      <!-- 作品信息（名称在上，编号在下） -->
      <span slot="product_info" slot-scope="text, row">
        <div style="cursor: pointer" @click="goDetail(row.id)">
          <div style="font-weight: bold; margin-bottom: 4px;">{{ row.name_cn }}</div>
          <div style="color: #666; font-size: 12px;">{{ row.pi_code }}</div>
        </div>
      </span>
      <!-- 作品名称英文 -->
      <span slot="name_en" slot-scope="text, row">
        <div style="cursor: pointer" @click="goDetail(row.id)">
          {{ text }}
        </div>
      </span>
      <!-- 初评状态 -->
      <span slot="status" slot-scope="text">
        <div :style="text === 0 ? '' : 'color: #ff0000;'">
          {{ text === 0 ? $t('admin-judge/noScore') : $t('admin-judge/hasScore') }}
        </div>
      </span>

      <!-- 操作 -->
      <span
        slot="operation"
        slot-scope="text, row"
      >
        <div style="display: flex; gap: 2px;">
          <a-button
            type="default"
            size="small"
            :disabled="row.is_recommended === 1"
            style="padding: 0 6px; font-size: 12px; background-color: #52c41a; border-color: #52c41a; color: white;"
            @click="submitRecommend(text, 1)"
          >
            推荐
          </a-button>
          <a-button
            type="default"
            size="small"
            :disabled="row.is_recommended === 0"
            style="padding: 0 6px; font-size: 12px; background-color: #ff4d4f; border-color: #ff4d4f; color: white;"
            @click="submitRecommend(text, 0)"
          >
            不推荐
          </a-button>
          <a-button
            type="default"
            size="small"
            style="padding: 0 6px; font-size: 12px; background-color: #1890ff; border-color: #1890ff; color: white;"
            @click="goDetail(text)"
          >
            详情
          </a-button>
        </div>
      </span>
    </a-table>
    <div style="height: 30px;" />
    <!-- 预览图组件 -->
    <PreviewImage v-if="previewVisible" :images="images" :index="imagesIndex" @closePreview="closePreview" />
  </div>
</template>
<script>
import { reviewsIndexBeforeByCate, reviewsPrimaryProduct } from '@/api/judge'
import request from '@/utils/request'
import PreviewImage from '@/views/components/PreviewImage'

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '70px'
  },
  {
    title: '作品图片',
    dataIndex: 'image',
    scopedSlots: { customRender: 'image' },
    width: '320px'
  },
  {
    title: '作品信息',
    dataIndex: 'product_info',
    scopedSlots: { customRender: 'product_info' }
  },
  // {
  //   title: '作品名称（英文）',
  //   dataIndex: 'name_en',
  //   scopedSlots: { customRender: 'name_en' },
  //   width: '160px'
  // },
  {
    title: '初评状态',
    dataIndex: 'status',
    width: '100px',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '分数',
    dataIndex: 'score',
    width: '60px'
  },
  {
    title: '操作',
    dataIndex: 'id',
    scopedSlots: { customRender: 'operation' },
    width: '180px'
  }
]

export default {
  components: {
    PreviewImage
  },
  data() {
    return {
      form: {
        search: '',
        status: '',
        user_id: ''
      },
      columns,
      list: [],
      users: [],
      review_num: 0, //  已评数量
      count: 0, // 总数
      recommend_num: 0, // 已推荐数量
      not_recommend_num: 0, // 未推荐数量
      max_num: null, // 分类最大推荐数
      images: [],
      imagesIndex: 0,
      previewVisible: false,
      pagination: {
        current: 1,
        total: 0
      }
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    user() {
      return this.$store.getters.user
    }
  },
  watch: {
    locale(e) {
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('admin-profile-product/images')
      this.columns[2].title = '作品信息'
      this.columns[3].title = this.$t('admin-judge/judgeStatus')
      this.columns[4].title = this.$t('admin-judge/score')
      this.columns[5].title = this.$t('admin-products-products/operating')
    }
  },
  created() {
    this.columns[0].title = this.$t('admin-judge/index')
    this.columns[1].title = this.$t('admin-profile-product/images')
    this.columns[2].title = '作品信息'
    this.columns[3].title = this.$t('admin-judge/judgeStatus')
    this.columns[4].title = this.$t('admin-judge/score')
    this.columns[5].title = this.$t('admin-products-products/operating')
    var page = localStorage.getItem('page')
    reviewsIndexBeforeByCate(1, this.$route.query.category_id).then(res => {
      this.users = res.users
      this.form.user_id = this.user.role === 3 ? this.user.id : res.users[0].id
      this.getList(Number(page))
      localStorage.removeItem('page')
    })
  },
  methods: {
    getList(page) {
      const data = {
        category_id: this.$route.query.category_id,
        search: this.form.search,
        status: this.form.status !== 0 ? (this.form.status || null) : 0,
        user_id: this.form.user_id,
        page: typeof page === 'number' ? page : 1
      }
      reviewsPrimaryProduct(data).then(res => {
        this.list = res.data
        this.review_num = res.review_num
        this.count = res.count
        this.recommend_num = res.recommend_num || 0
        this.not_recommend_num = res.not_recommend_num || 0
        this.max_num = res.max_num || null
        this.pagination.total = res.total
        this.pagination.current = res.current_page
      })
    },
    pageChange(e) {
      this.getList(e.current)
    },
    goDetail(e) {
      localStorage.setItem('page', this.pagination.current)
      this.$router.push({ path: '/admin/judgeDetail', query: { id: e, user_id: this.form.user_id }})
    },
    preview(images) {
      this.images = images.map(i => i.whole_image_url)
      this.imagesIndex = 0
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
    },
    submitRecommend(id, recommendValue) {
      // 调用初审推荐专用API
      request({
        url: `/reviews/product/primary/recommend/${id}/${recommendValue}`,
        method: 'put'
      }).then(res => {
        this.$message.success({ content: '初审推荐成功', key: 'message', duration: 4 })
        // 刷新列表
        this.getList(this.pagination.current)
      }).catch(error => {
        console.error('初审推荐失败:', error)
        this.$message.error('初审推荐失败，请重试')
      })
    }
  }
}
</script>
<style scoped>
  .searchBox {
    padding: 17px 20px;
    background: #ffffff;
    height: 92px;
  }

  .infoBox {
    background: #ffffff;
    width: 100%;
    border-radius: 2px;
    padding: 17px 20px;
    height: 92px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .infoBox span {
    margin-left: 10px;
  }

  .tag {
    width: 6em;
    line-height: 32px;
  }

  .table {
    margin-top: 30px;
  }

  .content {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width: 30vw;
  }
</style>
